import { useContext, useEffect, useState } from "react";
import DashboardContext from "../../Context/DashboardContext/DashboardContext";
import dashboardAPIs from "../../apis/dashboard/dashboardAPI";
import managerAPI from "../../apis/manager/managerAPI";
import Dashboard from "./Dashboard";
const Index = () => {
  const {
    setProductivityGraph,
    setFilterOptions,
    setAllocatedStatsData,
    setUnallocatedGraph,
  } = useContext(DashboardContext);

  useEffect(() => {
    // fetchUserStats();
    filterOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [productivityLoading, setProductivityLoading] = useState(false);
  const [allocatedLoading, setAllocatedLoading] = useState(false);
  const [unallocatedLoading, setUnallocatedLoading] = useState(false);
  const [globelFiltersValue, setGlobelFiltersValue] = useState({});
  const [allocationFiterValue, setAllocationFilterValue] = useState({});
  const [productivityFiterValue, setProductivityFilterValue] = useState({});
  const [completionIsChecked, setCompletionIsChecked] = useState(false);
  const [filterOptIsLoading, setFilterOptIsLoading] = useState(false);

  const fetchProductivity = async (payload) => {
    try {
      setProductivityLoading(true);
      let res = await dashboardAPIs.getGraphsProductivity(payload);
      setProductivityGraph(res);
      setProductivityLoading(false);
    } catch (e) {
      setProductivityLoading(false);
    }
  };

  const fetchAllocatedStats = async (payload) => {
    try {
      setAllocatedLoading(true);
      let allocatedStats = await dashboardAPIs.getGraphsAllocatedStats(payload);
      setAllocatedStatsData(allocatedStats);
      setAllocatedLoading(false);
    } catch (e) {
      setAllocatedLoading(false);
    }
  };

  const fetchUnallocatedGraph = async (payload) => {
    try {
      setUnallocatedLoading(true);
      let unallocatedData = await dashboardAPIs.getUnallocatedGraph(payload);
      setUnallocatedGraph(unallocatedData);
      setUnallocatedLoading(false);
    } catch (e) {
      setUnallocatedLoading(false);
    }
  };

  const filterOptions = async () => {
    try {
      setFilterOptIsLoading(true);
      let res = await managerAPI.getFilterOptions({
        filters: [
          "hold_reason",
          "worklist",
          "loc_name",
          "spec_name",
          "coder_name",
          "auditor_name",
          "milestone_name",
          "status_name",
          "sub_speciality_name",
        ],
      });
      let obj = {};
      if (res && res.success) {
        for (let a in res?.data) {
          if(a === "loc_name"){
            obj[a] = res.data[a].map((item) => ({
              label: item.name,
              value: item.id,
              client: item.ClientId,
            }));
          } else {
            obj[a] = res.data[a].map((item) => ({
              label: item.name,
              value: item.id,
            }));
          }
        }
      }
      setFilterOptions(obj);
      setFilterOptIsLoading(false);
    } catch (e) {
      setFilterOptIsLoading(false);
    }
  };

  const handleOnGlobelFilterChange = (val, name) => {
    let filterCopy = { ...globelFiltersValue };
    if (
      name === "location" ||
      name === "speciality" ||
      name === "auditor" ||
      name === "coder" ||
      name === "milestone" ||
      name === "chart_status" ||
      name === "Worklist"
    ) {
      filterCopy[name] = val?.map((item) => {
        return item.value;
      });
    } else {
      filterCopy[name] = val;
    }
    setGlobelFiltersValue(filterCopy);
  };

  const handleAllocatedFilterChange = (val, name) => {
    let filterCopy = { ...allocationFiterValue };
    if (
      name === "auditor" ||
      name === "coder" ||
      name === "milestone" ||
      name === "chart_status"
    ) {
      filterCopy[name] = val?.map((item) => {
        return item.value;
      });
    } else {
      filterCopy[name] = val;
    }
    setAllocationFilterValue(filterCopy);
  };

  const handleProductivityFilterChange = (val, name) => {
    let filterCopy = { ...productivityFiterValue };
    filterCopy[name] = val?.map((item) => {
      return item.value;
    });
    setProductivityFilterValue(filterCopy);
  };

  const globelFilterClick = async () => {
    try {
      let copy = { ...allocationFiterValue };
      if (completionIsChecked) {
        delete copy.date_of_completion;
      }
      fetchProductivity(globelFiltersValue);
      fetchAllocatedStats({ ...globelFiltersValue, ...copy });
      fetchUnallocatedGraph(globelFiltersValue);
    } catch (e) {
      console.log(e);
    }
  };

  const onAllocationFilterClick = () => {
    let copy = { ...allocationFiterValue };
    if (completionIsChecked) {
      copy.date_of_completion = null;
    }
    fetchAllocatedStats({ ...copy, ...globelFiltersValue });
  };

  const onProductivityFilterClick = () => {
    let copy = { ...productivityFiterValue };
    fetchProductivity({ ...copy, ...globelFiltersValue });
  };

  const isAttending =
    localStorage.getItem("attending") === "true" ? true : false;

  return (
    <>
      <Dashboard
        filterOptIsLoading={filterOptIsLoading}
        onProductivityFilterClick={onProductivityFilterClick}
        handleProductivityFilterChange={handleProductivityFilterChange}
        setCompletionIsChecked={setCompletionIsChecked}
        completionIsChecked={completionIsChecked}
        onAllocationFilterClick={onAllocationFilterClick}
        allocationFiterValue={allocationFiterValue}
        handleAllocatedFilterChange={handleAllocatedFilterChange}
        globelFiltersValue={globelFiltersValue}
        globelFilterClick={globelFilterClick}
        productivityLoading={productivityLoading}
        allocatedLoading={allocatedLoading}
        unallocatedLoading={unallocatedLoading}
        handleOnGlobelFilterChange={handleOnGlobelFilterChange}
        fetchAllocatedStats={fetchAllocatedStats}
        fetchUnallocatedGraph={fetchUnallocatedGraph}
        fetchProductivity={fetchProductivity}
        showtable={isAttending}
      />
    </>
  );
};
export default Index;
